export const formatDateString = (date) => {
	let d = new Date(date).toLocaleDateString('en-us', {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		weekday: 'long'
	});
	return d;
};

export const formatMonthYearString = (date) => {
	let d = new Date(date).toLocaleDateString('en-us', {
		month: 'short',
		year: 'numeric'
	});
	return d;
};

export const formatDate = (date) => {
	let d = new Date(date),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear();
	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;
	return [year, month, day].join('-');
};

export const formatDateTime = (dateStr) => {
	let date = new Date(dateStr);
	let hours = date.getHours();
	let minutes = date.getMinutes();
	let ampm = hours >= 12 ? 'pm' : 'am';
	hours = hours % 12;
	hours = hours ? hours : 12; // the hour '0' should be '12'
	minutes = minutes < 10 ? '0' + minutes : minutes;
	let strTime = hours + ':' + minutes + ' ' + ampm;
	return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear() + '  ' + strTime;
};
